import React from 'react';
import PlacesAutocomplete from 'react-places-autocomplete';
import Geocode from 'react-geocode';
import { LoadScript } from '@react-google-maps/api';
import styles from './MapSearch.module.scss';

Geocode.setApiKey(process.env.REACT_APP_GOOGLE_MAP_API);
Geocode.setLanguage('en');
Geocode.setRegion('us');

const LocationSearchInput = props => {
  const handleSelect = suggestion => {
    Geocode.fromAddress(suggestion.description)
      .then(
        response => {
          let item = response.results[0];
          let addresses = item.address_components || [];
          let zipCode = addresses.find(item => item.types.includes('postal_code'))?.long_name;
          props.onSelect({ ...suggestion, zipCode });
        },
        error => {
          props.onSelect({ ...suggestion, zipCode: '' });
        },
      )
      .catch(err => props.onSelect({ ...suggestion, zipCode: '' }));
  };

  return (
    <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAP_API} libraries={['places']}>
      <PlacesAutocomplete value={props.value} onChange={props.onChange} onSelect={() => null}>
        {({ getInputProps, suggestions, getSuggestionItemProps }) => (
          <div>
            {props.render(getInputProps({}))}
            <div className={styles.suggestionContainer}>
              {suggestions.map((suggestion, i) => {
                let suggestionProps = getSuggestionItemProps(suggestion, {});
                return (
                  <div
                    {...suggestionProps}
                    onClick={e => {
                      suggestionProps.onClick(e);
                      handleSelect(suggestion);
                    }}
                    key={i}
                    className="p-3 border"
                    style={{ cursor: 'pointer' }}
                  >
                    <span className="fa fa-map-marker text-muted mr-2"></span>
                    <span>
                      <b>{suggestion.formattedSuggestion.mainText}</b>
                    </span>{' '}
                    <span className="text-muted" style={{ fontSize: '14px' }}>
                      {suggestion.formattedSuggestion.secondaryText}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>
    </LoadScript>
  );
};

export default LocationSearchInput;
